<template>
  <input
    ref="input"
    type="text"
    inputmode="decimal"
    :value="modelValue"
    :placeholder="placeholder"
    :class="inputClass"
    :tabindex="tabindex"
    @focus="selectAll"
    @input="handleInput"
    @keydown="blockInvalidKeys" />
</template>

<script>
export default {
  name: 'QuoteLineNumberInput',
  emits: ['update:modelValue', 'change'],
  props: {
    modelValue: {
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputClass: {
      type: String,
      default: '',
    },
    tabindex: {
      type: [Number, String],
      default: undefined,
    },
  },
  methods: {
    selectAll(event) {
      event.target.select();
    },
    sanitize(value) {
      const cleaned = String(value)
        .replace(/[^\d.]/g, '')
        .replace(/(\..*)\./g, '$1');
      return cleaned;
    },
    handleInput(event) {
      const value = this.sanitize(event.target.value);
      if (value !== event.target.value) {
        event.target.value = value;
      }
      this.$emit('update:modelValue', value);
      this.$emit('change', value);
    },
    blockInvalidKeys(event) {
      if (['e', 'E', '+', '-'].includes(event.key)) {
        event.preventDefault();
      }
    },
  },
};
</script>
